// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WDX7","consentsList":"PatientConsents_consentsList__9lSAy","consentsListEmpty":"PatientConsents_consentsListEmpty__1DEqH"};